import { Row, Col } from 'antd'
import _ from 'lodash'
import classNames from 'classnames'
import { Loader } from '@vzmi/shp_shared_compo'
import styles from './WarehouseOverview.css'

import { Flag } from 'flag'
import { BaseStatHelper } from './Shared'

import { NoData } from '../../Common/StatePage'
import SPBaseModule from '../../../lib/SPBaseModule'
import { I13nAnchor } from '@vzmi/ec-react-i13n'

import { DEFAULT_UNSALABLE_THRESHOLD, WAREHOUSE_STAT_KEY_MAP } from '../../../constants/globalTypes'
import { getDefaultTimezoneMoment, getPeriodByBaseMoment, getBaseMomentByNoonGap, generateFullPeriodFormat, numeralFormat, convertDateByMoment } from '../../../../lib/renderUtil'
import { StatsCard } from './StatsCard/StatsCard'
import { PeriodInformation } from './PeriodInformation/PeriodInformation'
import DashboardSectionBody from '../../Common/DashboardSection/DashboardSectionBody'

class WarehouseHelper extends BaseStatHelper {}

const Helper = new WarehouseHelper(WAREHOUSE_STAT_KEY_MAP)

const WarehouseCardList = ({ items, className }) => {
  const listItems = !_.isEmpty(items)
    ? items.map(
      item => {
        const { key, value } = item
        const {
          format,
          flagName = '',
          text,
          tooltip,
          url,
          i13nModel
        } = Helper.getSetting(key)

        const formatedValue = numeralFormat(value, { format })
        let content = formatedValue

        if (!_.isEmpty(url) && formatedValue !== '--') {
          content = !_.isEmpty(i13nModel)
            ? (
              <I13nAnchor
                key={formatedValue}
                href={url}
                i13nModel={i13nModel}
              >
                {formatedValue}
              </I13nAnchor>
            )
            : (
              <a
                href={url}
                key={formatedValue}
              >
                {formatedValue}
              </a>
            )
        }

        return (
          <Col
            key={key}
            span={6}
          >
            {
              flagName
                ? (
                  <Flag name={flagName}>
                    <StatsCard
                      title={tooltip}
                      titleContent={text}
                      content={content}
                    />
                  </Flag>
                )
                : (
                  <StatsCard
                    key={key}
                    title={tooltip}
                    titleContent={text}
                    content={content}
                  />
                )
            }
          </Col>
        )
      }
    )
    : (
      <Col flex='auto'>
        <NoData iconType='history' />
      </Col>
    )

  return (
    <Row
      className={className}
      gutter={[12, 12]}
    >
      {listItems}
    </Row>
  )
}

class WarehouseOverview extends SPBaseModule {
  constructor (props) {
    super(props)

    this.state = {
      periodText: '',
      data: null
    }
  }

  componentDidMount () {
    this.fetchData()
  }

  fetchData = () => {
    const { fetchWarehouseOverview } = this.props
    // 資料統計至當日前一天、每日中午更新
    // convert base moment to default timezone (+8)
    const baseMoment = getDefaultTimezoneMoment(getBaseMomentByNoonGap())
    const period = generateFullPeriodFormat(getPeriodByBaseMoment(baseMoment))
    const periodObject = getPeriodByBaseMoment(baseMoment)
    const fetchPromise = this.promiseStateWrapper(fetchWarehouseOverview({ period, unsalableThreshold: DEFAULT_UNSALABLE_THRESHOLD }))
      .then((res) => {
        if (!res.error) {
          return _.get(res, 'payload', null)
        }
      })
      .then((inventoriesStat) => {
      /** set up success state */
        this.setIsSuccess(true)
        if (inventoriesStat) {
          const periodText = `${convertDateByMoment(periodObject.end, 'YYYY/MM/DD')}`
          this.setState({
            periodText,
            data: inventoriesStat
          })
        }
      })

    return fetchPromise
  }

  render () {
    const { className } = this.props
    const { isError, isLoading, periodText, data } = this.state
    const clz = classNames(styles.warehouseOverview, {
      [className]: !!className
    })
    return (
      <div
        className={clz}
        data-role='warehouse-overview'
      >
        <PeriodInformation noPaddingTop>
          {`資料統計至：${periodText} (至當日前一天、每日中午更新)`}
        </PeriodInformation>
        <DashboardSectionBody>
          <Loader
            className={styles.loader}
            loaded={!isLoading}
          >
            {
              isError
                ? this.renderIOError()
                : (<WarehouseCardList items={data} />)
            }
          </Loader>
        </DashboardSectionBody>
      </div>
    )
  }
}

export default WarehouseOverview
